module.exports = __webpack_public_path__ + "static/master-img2-5b0f72b25e00a4bb49bb79632b9814f3.jpg";